import { Entry } from 'contentful';
import { ILandingPage, IPageSection } from '../../../types/@types/generated/contentful';

export const isLandingPage = (reference: Entry<unknown>): reference is ILandingPage =>
  reference.sys.contentType.sys.id === 'landingPage';

export const isPageSection = (reference: Entry<unknown>): reference is IPageSection =>
  reference.sys.contentType.sys.id === 'pageSection';
